import script from "./EnvironmentSelect.vue?vue&type=script&setup=true&lang=js"
export * from "./EnvironmentSelect.vue?vue&type=script&setup=true&lang=js"

import "./EnvironmentSelect.vue?vue&type=style&index=0&id=1f202e2c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1f202e2c"]])

export default __exports__